import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  useNotificacaoList,
  useNotificacaoMarcarLida,
  useNotificacaoMarcarTodasLidas,
} from '../../hooks/useNotificacoes'
import styles from '../_shared/CrudPage.module.css'

const NIVEL_COR: Record<string, string> = {
  info: '#1565C0',
  warning: '#F57C00',
  critical: '#C62828',
}

export default function NotificacoesPage() {
  const navigate = useNavigate()
  const [filtroLida, setFiltroLida] = useState<'all' | 'unread'>('unread')
  const [filtroNivel, setFiltroNivel] = useState<'' | 'info' | 'warning' | 'critical'>('')

  const list = useNotificacaoList({
    ...(filtroLida === 'unread' ? { lida: false } : {}),
    ...(filtroNivel ? { nivel: filtroNivel } : {}),
  })

  const marcarTodas = useNotificacaoMarcarTodasLidas()

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Notificações</h1>
        <button
          type="button"
          onClick={() => marcarTodas.mutate()}
          disabled={marcarTodas.isPending}
          className={styles.btnPrimary ?? ''}
        >
          Marcar todas como lidas
        </button>
      </header>

      <div className={styles.toolbar}>
        <select
          value={filtroLida}
          onChange={(e) => setFiltroLida(e.target.value as 'all' | 'unread')}
          className={styles.search}
          style={{ maxWidth: '200px' }}
          aria-label="Filtrar por estado de leitura"
        >
          <option value="unread">Apenas não-lidas</option>
          <option value="all">Todas</option>
        </select>
        <select
          value={filtroNivel}
          onChange={(e) =>
            setFiltroNivel(e.target.value as '' | 'info' | 'warning' | 'critical')
          }
          className={styles.search}
          style={{ maxWidth: '200px' }}
          aria-label="Filtrar por nível de severidade"
        >
          <option value="">Todos os níveis</option>
          <option value="info">Info</option>
          <option value="warning">Atenção</option>
          <option value="critical">Crítico</option>
        </select>
      </div>

      {list.isLoading && <p className={styles.loading}>Carregando...</p>}
      {!list.isLoading && (list.data?.results ?? []).length === 0 && (
        <p className={styles.empty}>Nenhuma notificação encontrada.</p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {list.data?.results.map((n) => (
          <NotifRow
            key={n.id}
            notif={n}
            onClick={() => {
              if (n.link) navigate(n.link)
            }}
          />
        ))}
      </div>
    </div>
  )
}

function NotifRow({
  notif,
  onClick,
}: {
  notif: import('../../types').Notificacao
  onClick: () => void
}) {
  const marcarLida = useNotificacaoMarcarLida(notif.id)
  return (
    <div
      data-testid={`notif-row-${notif.id}`}
      onClick={() => {
        if (!notif.lida) void marcarLida.mutateAsync().catch(() => {})
        onClick()
      }}
      style={{
        padding: '1rem',
        background: notif.lida ? '#FAFAFA' : 'white',
        borderLeft: `4px solid ${NIVEL_COR[notif.nivel] ?? '#888'}`,
        borderRadius: '4px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        cursor: notif.link ? 'pointer' : 'default',
        opacity: notif.lida ? 0.7 : 1,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem' }}>
        <strong>{notif.titulo}</strong>
        <span style={{ fontSize: '0.75rem', color: '#5a6168' }}>
          {new Date(notif.criada_em).toLocaleString('pt-BR')}
        </span>
      </div>
      <p style={{ margin: '0.25rem 0 0', fontSize: '0.9rem', color: '#444' }}>
        {notif.mensagem}
      </p>
      {notif.tipo_display && (
        <span
          style={{
            display: 'inline-block',
            marginTop: '0.5rem',
            fontSize: '0.7rem',
            padding: '0.1rem 0.5rem',
            background: '#F0F0F0',
            borderRadius: '999px',
            color: '#555',
          }}
        >
          {notif.tipo_display}
        </span>
      )}
    </div>
  )
}
